import Generic from './Generic'

const transitions = [Generic]

export default transitions



// WEBPACK FOOTER //
// ./scripts/transitions/index.js